import React from "react"
import { Switch } from "react-router"
import PrivateRoute from "./PrivateRoute"
import Dashboard from "../../pages/dashboard/Dashboard"
import AdminRegistry from "../../pages/AdminRegistryPage/AdminRegistry"
import GiftTracker from "../../pages/gift_tracker/GiftTracker"
import { EventContextProvider } from "../../context/EventContext"
import CreateEvent from "../../pages/event/CreateEvent"
import ConfirmAccount from "../../pages/ConfirmAccount/ConfirmAccount"
import SendGift from "../../pages/ConfirmAccount/SendGift"
import UpdateEvent from "../../pages/event/UpdateEvent"
import Checklist from "../../pages/checklist/Checklist"

export const AdminRoutesList = [
  { path: "/dashboard", exact: true, component: Dashboard },
  { path: "/registry/:id", exact: true, component: AdminRegistry },
  { path: "/gift-tracker", exact: true, component: GiftTracker },
  {
    path: "/create-event",
    exact: true,
    component: () => (
      <EventContextProvider>
        <CreateEvent />
      </EventContextProvider>
    )
  },
  {
    path: "/gift-tracker/cash/:orderId",
    exact: true,
    component: ConfirmAccount
  },
  { path: "/gift-tracker/gift/:orderId", exact: true, component: SendGift },
  { path: "/update-event", exact: true, component: UpdateEvent },
  { path: "/checklist", exact: true, component: Checklist }
]

const AdminRoutes = () => {
  return (
    <Switch>
      <EventContextProvider>
        {AdminRoutesList.map(r => (
          <PrivateRoute
            path={r.path}
            component={r.component}
            exact={r.exact}
            key={r.path}
          />
        ))}
      </EventContextProvider>
    </Switch>
  )
}

export default AdminRoutes
